import { getSupabaseBrowserClient } from './supabase/browser';

/**
 * Fetch wrapper that automatically attaches the current Supabase access
 * token as a Bearer header.
 *
 * Replaces bare `fetch('/api/...')` calls that used to rely on
 * cookie-based auth flowing through the Next.js middleware. Hono's
 * auth middleware reads the Authorization header instead.
 *
 * Token refresh is handled entirely by the Supabase browser client:
 * we read the current session on every call, so freshly-refreshed
 * tokens are used automatically.
 */
export async function apiFetch(
  input: RequestInfo | URL,
  init: RequestInit = {},
): Promise<Response> {
  const supabase = getSupabaseBrowserClient();
  const {
    data: { session },
  } = await supabase.auth.getSession();
  const token = session?.access_token;

  const headers = new Headers(init.headers);
  if (token && !headers.has('Authorization')) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  return fetch(input, { ...init, headers });
}
